import { render, staticRenderFns } from "./ot-document-associations.vue?vue&type=template&id=694a844c&scoped=true&"
import script from "./ot-document-associations.vue?vue&type=script&lang=ts&"
export * from "./ot-document-associations.vue?vue&type=script&lang=ts&"
import style0 from "./ot-document-associations.vue?vue&type=style&index=0&id=694a844c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694a844c",
  null
  
)

export default component.exports